// Den fasta topbaren är 64 px, resten är luft
export const SCROLL_OFFSET = 80;

// Sektionens position i layouten, utan transformer. MotionDiv sätter sektioner 24 px för lågt
// tills de tonats in, och getBoundingClientRect (som react-scroll använder) räknar med det. Då
// hamnar sektionen 24 px för högt när animationen väl är klar och toppen göms bakom topbaren.
const layoutTop = (el) => {
  let top = 0;
  for (let node = el; node; node = node.offsetParent) top += node.offsetTop;
  return top;
};

export const scrollToSection = (id, { smooth = false } = {}) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({
    top: Math.max(0, layoutTop(el) - SCROLL_OFFSET),
    behavior: smooth ? "smooth" : "auto",
  });
};
